import React, { useState, useEffect } from 'react';
import { api } from '../../config/api';

const CreateWordListForm = ({ onClose, onSuccess }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [languageId, setLanguageId] = useState('');
  const [languages, setLanguages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const data = await api.getLanguages();
        setLanguages(data);
        if (data.length > 0) {
          setLanguageId(data[0].id);
        }
      } catch (err) {
        setError('Nie udało się pobrać języków');
      }
    };

    fetchLanguages();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const data = await api.createWordList({
        name,
        description,
        languageId
      });
      setName('');
      setDescription('');
      setIsLoading(false);
      onSuccess && onSuccess(data);
      onClose && onClose();
    } catch (err) {
      setError(err.message || 'Wystąpił błąd podczas tworzenia listy');
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-sm font-semibold mb-4">Nowa lista słówek</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="block text-xs font-medium text-neutral-700 mb-1">
            Nazwa listy
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2 text-xs border border-neutral-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500"
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="block text-xs font-medium text-neutral-700 mb-1">
            Opis (opcjonalnie)
          </label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full px-3 py-2 text-xs border border-neutral-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 h-20 resize-none"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="language" className="block text-xs font-medium text-neutral-700 mb-1">
            Język
          </label>
          <select
            id="language"
            value={languageId}
            onChange={(e) => setLanguageId(e.target.value)}
            className="w-full px-3 py-2 text-xs border border-neutral-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500"
            required
          >
            {languages.map(lang => (
              <option key={lang.id} value={lang.id}>
                {lang.name}
              </option>
            ))}
          </select>
        </div>
        {error && (
          <div className="mb-4 p-3 text-sm bg-red-50 text-red-600 rounded-md">
            {error}
          </div>
        )}
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 text-xs font-medium text-neutral-700 bg-white border border-neutral-300 rounded-md hover:bg-neutral-50 transition-colors"
          >
            Anuluj
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="px-3 py-1.5 text-xs font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Tworzenie...' : 'Utwórz listę'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateWordListForm; 